import { render, staticRenderFns } from "./CalendarReport.vue?vue&type=template&id=1952992c&"
import script from "./CalendarReport.vue?vue&type=script&lang=ts&"
export * from "./CalendarReport.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports